export const colors = {
  basicBlue: {
    light: '#DDEFFF',
    default: '#b0d9fc',
    dark: '#86C6FE',
    darker: '#3aa2f8',
    darkest: '#034C8C',
  },
};